import ApiService from 'app/services/ApiService';
export const MANAGEMENT_REPORT_FILTERS_SUCCESS = 'MANAGEMENT_REPORT_FILTERS_SUCCESS';
export const MANAGEMENT_REPORT_FILTERS_BEGIN = 'MANAGEMENT_REPORT_FILTERS_BEGIN';
export const MANAGEMENT_REPORT_FILTERS_FAILURE = 'MANAGEMENT_REPORT_FILTERS_FAILURE';
export const CLEAR_MANAGEMENT_REPORT_FILTERS = 'CLEAR_MANAGEMENT_REPORT_FILTERS';

export const MANAGEMENT_REPORT_SUCCESS = 'MANAGEMENT_REPORT_SUCCESS';
export const MANAGEMENT_REPORT_BEGIN = 'MANAGEMENT_REPORT_BEGIN';
export const MANAGEMENT_REPORT_FAILURE = 'MANAGEMENT_REPORT_FAILURE';
export const CLEAR_MANAGEMENT_REPORT = 'CLEAR_MANAGEMENT_REPORT';


export function fetchManagementReportFilters(params = {}) {
    return async dispatch => {
        dispatch(managementReportFiltersBegin());
        await ApiService.getManagementReportFilter(params)
        .then(
            result => {
                dispatch(managementReportFiltersSuccess(result));
            },
            error => {
                dispatch(managementReportFiltersError());
                throw ({ error: error, message: 'An error ocurred' });
            }
        )
    };
}

export function fetchManagementReport(data, id) {
    return async dispatch => {
        dispatch(managementReportBegin());
        await ApiService.getManagementReport(data, id)
        .then(
            result => {
                dispatch(managementReportSuccess(result));
            },
            error => {
                dispatch(managementReportError());
                throw ({ error: error, message: 'An error ocurred' });
            }
        )
    };
}

export const managementReportFiltersBegin = () =>({
    type: MANAGEMENT_REPORT_FILTERS_BEGIN
})
export const managementReportFiltersSuccess = (data) =>({
    type: MANAGEMENT_REPORT_FILTERS_SUCCESS,
    payload: { data }
})
export const managementReportFiltersError = () =>({
    type: MANAGEMENT_REPORT_FILTERS_FAILURE
})
export const clearManagementReportFilter = () => ({
    type: CLEAR_MANAGEMENT_REPORT_FILTERS,
});

export const managementReportBegin = () =>({
    type: MANAGEMENT_REPORT_BEGIN
})
export const managementReportSuccess = (data) =>({
    type: MANAGEMENT_REPORT_SUCCESS,
    payload: { data }
})
export const managementReportError = () =>({
    type: MANAGEMENT_REPORT_FAILURE
})
export const clearManagementReport = () => ({
    type: CLEAR_MANAGEMENT_REPORT,
});
